export default __webpack_public_path__ + "static/feature-templates-8ab99c27b232146eee1acb6e07d9aa32.webp";